import { setChargingPopUp } from "@/utils/service";
const layout={
    state: {
        isCollaps:false,
        isMenuCollapse: false,
        isInitWs: false,
        searchArr: [],
        showArrearsDialog: false,
        refreshIndex: 0,
        settingConfig: {},
        showPassInStr: undefined,
        isSentryBoxTabs: undefined,
        showLeftSide: true,
    },
    mutations: {
        SET_COLLAPS:(state)=>{
            state.isCollaps=!state.isCollaps
        },
        SET_MENUCOLLAPSE:(state)=>{
            state.isMenuCollapse=!state.isMenuCollapse
        },
        SET_INITWS: (state, isInitWs) => {
            state.isInitWs = isInitWs;
        },
        SET_SearchArr: (state, searchArr) => {
            state.searchArr = searchArr;
        },
        SET_ShowArrearsDialog: (state, showArrearsDialog) => {
            state.showArrearsDialog = showArrearsDialog;
        },
        SET_RefreshIndex: (state, refreshIndex) => {
            state.refreshIndex = refreshIndex;
        },
        SET_SettingConfig: (state, settingConfig) => {
            state.settingConfig = settingConfig;
        },
        SET_ShowPassInStr: (state, showPassInStr) => {
            state.showPassInStr = showPassInStr;
        },
        SET_IsSentryBoxTabs: (state, isSentryBoxTabs) => {
            state.isSentryBoxTabs = isSentryBoxTabs;
            sessionStorage.setItem('isSentryBoxTabs', isSentryBoxTabs);
        },
        SET_ShowLeftSide: (state, showLeftSide) => {
            state.showLeftSide = showLeftSide;
        },
    },
    actions: {
        ToggleCollaps({commit}){
            commit('SET_COLLAPS')
        },
        ToggleMenuCollapse({commit}){
            commit('SET_MENUCOLLAPSE')
        },
        SetInitWs: ({ commit }, isInitWs) => {
            commit("SET_INITWS", isInitWs);
        },
        SetSearchArr: ({ commit }, searchArr) => {
            commit("SET_SearchArr", searchArr);
        },
        SetShowArrearsDialog: ({ commit }, showArrearsDialog) => {
            commit("SET_ShowArrearsDialog", showArrearsDialog);
        },
        SetRefreshIndex: ({ commit }, refreshIndex) => {
            commit("SET_RefreshIndex", refreshIndex);
        },
        SetSettingConfig: ({ commit }, settingConfig) => {
            commit("SET_SettingConfig", settingConfig);
            setChargingPopUp(JSON.stringify(settingConfig));
        },
        SetShowPassInStr: ({ commit }, showPassInStr) => {
            commit("SET_ShowPassInStr", showPassInStr);
        },
        SetIsSentryBoxTabs: ({ commit }, isSentryBoxTabs) => {
            commit("SET_IsSentryBoxTabs", isSentryBoxTabs);
        },
        SetShowLeftSide: ({ commit }, showLeftSide) => {
            commit("SET_ShowLeftSide", showLeftSide);
        },
    },
}
export default layout;
